"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Nullable = require("../Data.Nullable/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Effect = require("../Effect/index.js");
var Effect_Timer = require("../Effect.Timer/index.js");
var Global = require("../Global/index.js");
var Prelude = require("../Prelude/index.js");
var React_Basic = require("../React.Basic/index.js");
var React_Basic_DOM = require("../React.Basic.DOM/index.js");
var React_Basic_DOM_Generated = require("../React.Basic.DOM.Generated/index.js");
var React_Basic_Events = require("../React.Basic.Events/index.js");
var React_Basic_Hooks = require("../React.Basic.Hooks/index.js");
var Type_Equality = require("../Type.Equality/index.js");
var UseInput = require("../UseInput/index.js");

// | Time Unit type
var Second = (function () {
    function Second(value0) {
        this.value0 = value0;
    };
    Second.create = function (value0) {
        return new Second(value0);
    };
    return Second;
})();

// | Time Unit type
var Minute = (function () {
    function Minute(value0) {
        this.value0 = value0;
    };
    Minute.create = function (value0) {
        return new Minute(value0);
    };
    return Minute;
})();

// | Time Unit type
var Hour = (function () {
    function Hour(value0) {
        this.value0 = value0;
    };
    Hour.create = function (value0) {
        return new Hour(value0);
    };
    return Hour;
})();
var Running = (function () {
    function Running() {

    };
    Running.value = new Running();
    return Running;
})();
var Paused = (function () {
    function Paused() {

    };
    Paused.value = new Paused();
    return Paused;
})();
var Stopped = (function () {
    function Stopped() {

    };
    Stopped.value = new Stopped();
    return Stopped;
})();

// | Percent type
var Percent = function (x) {
    return x;
};

// | Milliseconds type
// The only reason why I exclude it from `TimeUnit` is because
// I just want to play around the concept of `Newtype`
// and `derive newtype instance`
var Milliseconds = function (x) {
    return x;
};

// | Reducer actions
var Start = (function () {
    function Start(value0) {
        this.value0 = value0;
    };
    Start.create = function (value0) {
        return new Start(value0);
    };
    return Start;
})();

// | Reducer actions
var Update = (function () {
    function Update() {

    };
    Update.value = new Update();
    return Update;
})();

// | Reducer actions
var Pause = (function () {
    function Pause() {

    };
    Pause.value = new Pause();
    return Pause;
})();

// | Reducer actions
var Resume = (function () {
    function Resume() {

    };
    Resume.value = new Resume();
    return Resume;
})();

// | Reducer actions
var Reset = (function () {
    function Reset() {

    };
    Reset.value = new Reset();
    return Reset;
})();
var ToMilliseconds = function (toMilliseconds) {
    this.toMilliseconds = toMilliseconds;
};
var toMsTimeUnit = new ToMilliseconds(function (v) {
    if (v instanceof Second) {
        return Milliseconds(v.value0 * 1000.0);
    };
    if (v instanceof Minute) {
        return Milliseconds(v.value0 * 1000.0 * 60.0);
    };
    if (v instanceof Hour) {
        return Milliseconds(v.value0 * 1000.0 * 60.0 * 60.0);
    };
    throw new Error("Failed pattern match at Container (line 40, column 1 - line 40, column 49): " + [ v.constructor.name ]);
});
var toMilliseconds = function (dict) {
    return dict.toMilliseconds;
};
var timeUnitConst = {
    seconds: "seconds",
    minutes: "minutes",
    hours: "hours"
};
var toTimeUnit = function (tAmount) {
    return function (tUnit) {
        if (tUnit === timeUnitConst.seconds) {
            return Second.create(Global.readFloat(tAmount));
        };
        if (tUnit === timeUnitConst.minutes) {
            return Minute.create(Global.readFloat(tAmount));
        };
        if (tUnit === timeUnitConst.hours) {
            return Hour.create(Global.readFloat(tAmount));
        };
        if (Data_Boolean.otherwise) {
            return new Second(0.0);
        };
        throw new Error("Failed pattern match at Container (line 55, column 1 - line 55, column 43): " + [ tAmount.constructor.name, tUnit.constructor.name ]);
    };
};
var showPercent = new Data_Show.Show(function (v) {
    return Data_Show.show(Data_Show.showNumber)(v) + "%";
});
var showMs = new Data_Show.Show(function (v) {
    return Data_Show.show(Data_Show.showNumber)(v) + "ms";
});
var semiringMs = Data_Semiring.semiringNumber;
var ringMs = Data_Ring.ringNumber;
var ordMs = Data_Ord.ordNumber;
var newtypeMs = new Data_Newtype.Newtype(function (n) {
    return n;
}, Milliseconds);
var msToStyle = function (original) {
    return function (v) {
        var percentToCss = function (p) {
            return React_Basic_DOM.css({
                "--percent": Data_Show.show(showPercent)(p)
            });
        };
        var original$prime = Data_Newtype.unwrap(newtypeMs)(toMilliseconds(toMsTimeUnit)(original));
        var msToPercent = (function () {
            var percentage = ((original$prime - v) / original$prime) * 100.0;
            return percentage;
        })();
        return percentToCss(msToPercent);
    };
};

// | Update state every 100ms
var intervalTime = 100.0;
var initialState = {
    progress: Stopped.value,
    msRemaining: Data_Semiring.zero(semiringMs)
};
var eqProgress = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Running && y instanceof Running) {
            return true;
        };
        if (x instanceof Paused && y instanceof Paused) {
            return true;
        };
        if (x instanceof Stopped && y instanceof Stopped) {
            return true;
        };
        return false;
    };
});
var reducer = function ($copy_state) {
    return function ($copy_v) {
        var $tco_var_state = $copy_state;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(state, v) {
            if (v instanceof Start) {
                var $34 = Data_Eq.eq(eqProgress)(state.progress)(Paused.value) || Data_Eq.eq(eqProgress)(state.progress)(Stopped.value);
                if ($34) {
                    $tco_done = true;
                    return {
                        progress: Running.value,
                        msRemaining: toMilliseconds(toMsTimeUnit)(v.value0)
                    };
                };
                $tco_done = true;
                return {
                    progress: state.progress,
                    msRemaining: toMilliseconds(toMsTimeUnit)(v.value0)
                };
            };
            if (v instanceof Update) {
                var newRemaining = Data_Ring.sub(ringMs)(state.msRemaining)(intervalTime);
                var $36 = Data_Ord.lessThanOrEq(ordMs)(newRemaining)(Data_Semiring.zero(semiringMs));
                if ($36) {
                    $tco_var_state = state;
                    $copy_v = Reset.value;
                    return;
                };
                $tco_done = true;
                return {
                    progress: state.progress,
                    msRemaining: newRemaining
                };
            };
            if (v instanceof Pause) {
                $tco_done = true;
                return {
                    progress: Paused.value,
                    msRemaining: state.msRemaining
                };
            };
            if (v instanceof Resume) {
                $tco_done = true;
                return {
                    progress: Running.value,
                    msRemaining: state.msRemaining
                };
            };
            if (v instanceof Reset) {
                $tco_done = true;
                return initialState;
            };
            throw new Error("Failed pattern match at Container (line 93, column 17 - line 105, column 24): " + [ v.constructor.name ]);
        };
        while (!$tco_done) {
            $tco_result = $tco_loop($tco_var_state, $copy_v);
        };
        return $tco_result;
    };
};

// | THE component
var stopwatch = React_Basic_Hooks.component("Stopwatch")(function (props) {
    return React_Basic_Hooks.bind(React_Basic_Hooks.ixBindRender)(React_Basic_Hooks.useReducer(initialState)(reducer))(function (v) {
        return React_Basic_Hooks.bind(React_Basic_Hooks.ixBindRender)(UseInput.useInput("0"))(function (v1) {
            return React_Basic_Hooks.bind(React_Basic_Hooks.ixBindRender)(UseInput.useInput("seconds"))(function (v2) {
                return React_Basic_Hooks.bind(React_Basic_Hooks.ixBindRender)(React_Basic_Hooks.useRef(Data_Nullable["null"]))(function (v3) {
                    var readFromInput = toTimeUnit(v1.value)(v2.value);
                    var stopStopwatch = function __do() {
                        var v4 = React_Basic_Hooks.readRefMaybe(v3)();
                        if (v4 instanceof Data_Maybe.Just) {
                            return Effect_Timer.clearInterval(v4.value0)();
                        };
                        if (v4 instanceof Data_Maybe.Nothing) {
                            return Data_Monoid.mempty(Data_Monoid.monoidUnit);
                        };
                        throw new Error("Failed pattern match at Container (line 118, column 9 - line 120, column 35): " + [ v4.constructor.name ]);
                    };
                    return React_Basic_Hooks.discard(React_Basic_Hooks.ixBindRender)(React_Basic_Hooks.useEffect(eqProgress)(v.value0.progress)((function () {
                        var intervalTimeInInt = Data_Maybe.fromMaybe(0)(Data_Int.fromNumber(Data_Newtype.unwrap(newtypeMs)(intervalTime)));
                        return function __do() {
                            (function () {
                                var $44 = Data_Eq.eq(eqProgress)(v.value0.progress)(Running.value);
                                if ($44) {
                                    var v4 = Effect_Timer.setInterval(intervalTimeInInt)(v.value1(Update.value))();
                                    return React_Basic_Hooks.writeRef(v3)(Data_Nullable.toNullable(new Data_Maybe.Just(v4)))();
                                };
                                return stopStopwatch();
                            })();
                            return stopStopwatch;
                        };
                    })()))(function () {
                        return Control_Applicative.pure(React_Basic_Hooks.applicativeRender(Type_Equality.refl))(React_Basic_DOM_Generated.div_([ React_Basic_DOM_Generated.h1_([ React_Basic_DOM.text("Stopwatch for your 5-year old kid") ]), React_Basic_DOM_Generated.div()({
                            className: "container",
                            children: [ React_Basic_DOM_Generated.div()({
                                className: "circle circle--green"
                            }), React_Basic_DOM_Generated.div()({
                                className: "circle circle--red",
                                style: (function () {
                                    var $46 = Data_Eq.notEq(eqProgress)(v.value0.progress)(Stopped.value);
                                    if ($46) {
                                        return msToStyle(readFromInput)(v.value0.msRemaining);
                                    };
                                    return React_Basic_DOM.css({});
                                })()
                            }), React_Basic_DOM_Generated.div()({
                                className: "control",
                                children: [ React_Basic_DOM_Generated.input()({
                                    type: "number",
                                    value: v1.value,
                                    onChange: v1.onChange
                                }), React_Basic_DOM_Generated.select()({
                                    name: "unit",
                                    value: v2.value,
                                    onChange: v2.onChange,
                                    children: [ React_Basic_DOM_Generated.option()({
                                        value: timeUnitConst.seconds,
                                        children: [ React_Basic_DOM.text(timeUnitConst.seconds) ]
                                    }), React_Basic_DOM_Generated.option()({
                                        value: timeUnitConst.minutes,
                                        children: [ React_Basic_DOM.text(timeUnitConst.minutes) ]
                                    }), React_Basic_DOM_Generated.option()({
                                        value: timeUnitConst.hours,
                                        children: [ React_Basic_DOM.text(timeUnitConst.hours) ]
                                    }) ]
                                }) ]
                            }), React_Basic_DOM_Generated.div()({
                                className: "control",
                                children: [ React_Basic_DOM_Generated.button()({
                                    onClick: React_Basic_Events.handler_(v.value1(new Start(readFromInput))),
                                    children: [ React_Basic_DOM.text("Start") ]
                                }), (function () {
                                    if (v.value0.progress instanceof Stopped) {
                                        return Data_Monoid.mempty(React_Basic.monoidJSX);
                                    };
                                    if (v.value0.progress instanceof Running) {
                                        return React_Basic_DOM_Generated.button()({
                                            onClick: React_Basic_Events.handler_(v.value1(Pause.value)),
                                            children: [ React_Basic_DOM.text("Pause") ]
                                        });
                                    };
                                    if (v.value0.progress instanceof Paused) {
                                        return React_Basic_DOM_Generated.button()({
                                            onClick: React_Basic_Events.handler_(v.value1(Resume.value)),
                                            children: [ React_Basic_DOM.text("Resume") ]
                                        });
                                    };
                                    throw new Error("Failed pattern match at Container (line 171, column 17 - line 174, column 110): " + [ v.value0.progress.constructor.name ]);
                                })(), React_Basic_DOM_Generated.button()({
                                    onClick: React_Basic_Events.handler_(v.value1(Reset.value)),
                                    children: [ React_Basic_DOM.text("Reset") ]
                                }) ]
                            }) ]
                        }) ]));
                    });
                });
            });
        });
    });
});
var eqMs = Data_Eq.eqNumber;
module.exports = {
    stopwatch: stopwatch
};
